module.exports = __webpack_public_path__ + "static/media/agricultural14.f41531db.jpg";